import { Skeleton } from 'components/Skeleton';
import { useGetBlockCloneContentQuery } from 'features/documents/documents';
import Parser from 'html-react-parser';
import { useGetArea } from 'pages/documents_v2/hooks/useGetArea';
import { Button, Modal } from 'react-bootstrap';
import { CheckCircleFill, ChevronRight, XCircle } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';

import { FormModal } from '../../global/FormModal';
import { useGetDocuments } from '../hooks/useGetDocuments';

export function PreviousBlockVersionsModal({ block, handleClose }) {
    const { t } = useTranslation('documents');

    return (
        <FormModal
            show={true}
            onHide={handleClose}
            title={t('document.navbar.main.editor.left.blocks.modals.previousBlockVersionsModal.compare')}
            size="lg"
            scrollable={true}
        >
            <>
                <Modal.Body>
                    <Block id={block.id} />
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="btn btn-secondary" onClick={() => handleClose()}>
                        {t('btn.close')}
                    </Button>
                </Modal.Footer>
            </>
        </FormModal>
    );
}

function Block({ id }) {
    const { t } = useTranslation('documents');

    const { blocks } = useGetBlockCloneContentQuery(id, {
        selectFromResult: ({ data }) => ({
            blocks: data,
        }),
    });

    return (
        <div>
            {!blocks && (
                <div className="px-4">
                    <Skeleton />
                    <div className="small bg-light dr-container p-3 mt-2">
                        <Skeleton count={3} />
                    </div>
                </div>
            )}

            {blocks && blocks.length === 0 && (
                <div>
                    <p>{t('document.navbar.main.editor.left.blocks.modals.previousBlockVersionsModal.identical')}</p>
                </div>
            )}

            {blocks && blocks.map((block, index) => <BlockContent data={block} key={`block-${id}-content-${index}`} />)}
        </div>
    );
}

function BlockContent({ data }) {
    const { areaId, oldContextId, isDifferent = false } = data;
    const area = useGetArea(areaId);
    const documents = useGetDocuments();

    const document = documents.find((_document) => _document.id === parseInt(oldContextId));

    if (!document && !area) {
        return null;
    }

    return (
        <div className="px-4 mb-4">
            <div className="flex-center mb-3">
                {isDifferent ? <XCircle className="text-danger" /> : <CheckCircleFill className="text-success" />}
                {document && <div className="font-weight-bold mx-1">{document.name}</div>}
                {document && area && <ChevronRight />}
                {area && <div className="text-secondary">{area.title}</div>}
            </div>

            <div className="read-only-content small bg-light dr-container p-3">{Parser(data.diffContent)}</div>
        </div>
    );
}
